import { ETH_CHAIN_ID } from '@app/config/env'
import { useChainId } from 'wagmi'

import useLocked from './useLocked'

const DISCOUNTS = [
  {
    value: 0,
    discount: 4,
  },
  {
    value: 1000,
    discount: 3,
  },
  {
    value: 10000,
    discount: 2,
  },
  {
    value: 100000,
    discount: 1,
  },
]

const MAIN_DISCOUNTS = [
  {
    value: 0,
    discount: 1,
  },
  {
    value: 1000,
    discount: 0.75,
  },
  {
    value: 10000,
    discount: 0.5,
  },
  {
    value: 100000,
    discount: 0.25,
  },
]

const calculateCurrentDiscountValue = (v: number) => {
  return DISCOUNTS.find((item) => item.value === v)?.discount
}

const calculateCurrentBuyDiscountValue = (v: number) => {
  return MAIN_DISCOUNTS.find((item) => item.value === v)?.discount
}

export const useMintFee = (): any => {
  //const chainId = useChainId()
  const locked = useLocked()

  return calculateCurrentBuyDiscountValue(Number(locked.value) / 10 ** 8)
}

export default (): any => {
  const chainId = useChainId()
  const locked = useLocked()

  if (chainId == Number(ETH_CHAIN_ID)) {
    return calculateCurrentBuyDiscountValue(Number(locked.value) / 10 ** 8)
  } else {
    return calculateCurrentDiscountValue(Number(locked.value) / 10 ** 8)
  }
}

export const useBurnFee = (token: string): any => {
  const locked = useLocked()

  if (token != 'CST') {
    return calculateCurrentBuyDiscountValue(Number(locked.value) / 10 ** 8)
  } else {
    return calculateCurrentDiscountValue(Number(locked.value) / 10 ** 8)
  }
}
